import { render, staticRenderFns } from "./BuddhaReply.vue?vue&type=template&id=99d8945a"
import script from "./BuddhaReply.vue?vue&type=script&lang=js"
export * from "./BuddhaReply.vue?vue&type=script&lang=js"
import style0 from "./BuddhaReply.vue?vue&type=style&index=0&id=99d8945a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports